/*
  Garage Golf swatch details pop-up. Loaded only by snippets/gg-swatch-info.liquid, which
  writes the GG Swatch Info entries into the page. This script matches each entry to its
  Easify choice (option title plus choice label, trimmed, case insensitive, price text
  ignored), adds a Details button under each matched choice, shows a hover preview on
  desktop photo swatches, and opens the full details on Details (a bottom sheet under 750px).
  It never selects, unselects or reprices a choice; choices with no entry are left alone.
*/
(function () {
  if (window.ggSwatchInfo) return;
  window.ggSwatchInfo = true;

  var panel = document.getElementById('gg-si-panel');
  if (!panel) return;
  var backdrop = document.querySelector('.gg-si-backdrop');
  var photo = panel.querySelector('.gg-si-photo');
  var closeBtn = panel.querySelector('.gg-si-close');
  var moreBtn = panel.querySelector('.gg-si-more');
  var entries = Array.prototype.slice.call(panel.querySelectorAll('.gg-si-entry'));
  if (!entries.length) return;

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v6M12 7.5v.5"/></svg>';
  var mqHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var mqNarrow = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var state = { mode: null, entry: null, item: null, btn: null, hideT: null };

  function norm(s) {
    return String(s || '')
      .replace(/\(?\s*[+-]?\s*\$\s*[\d,]+(\.\d{1,2})?\s*\)?/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }
  function clean(s) { return String(s || '').replace(/\(?\s*[+-]?\s*\$\s*[\d,]+(\.\d{1,2})?\s*\)?/g, ' ').replace(/\s+/g, ' ').trim(); }
  function hoverable() { return !!(mqHover && mqHover.matches) && !(mqNarrow && mqNarrow.matches); }
  function narrow() { return !!(mqNarrow && mqNarrow.matches); }
  function big(src) { return (src || '').replace(/_(\d+)x(\d*)(\.[a-z]+)/i, '_900x$3'); }
  function stop(e) { e.preventDefault(); e.stopPropagation(); }

  var byKey = {};
  entries.forEach(function (en) {
    byKey[norm(en.getAttribute('data-option')) + '||' + norm(en.getAttribute('data-choice'))] = en;
  });

  function optionTitle(container) {
    var t = container.querySelector('.tpo_option-label-container > .form__label') || container.querySelector('.form__label');
    return t ? t.textContent : '';
  }
  function itemLabel(item) {
    var t = item.querySelector('.tpo_option_label');
    if (t) return t.textContent;
    var i = item.querySelector('input');
    return i ? i.value : '';
  }
  function itemPhoto(item) {
    var lab = item.querySelector('label');
    if (!lab || !lab.classList.contains('tpo_shape_radius')) return '';
    var img = item.querySelector('.tpo_image-wrapper img');
    return img ? big(img.currentSrc || img.src) : '';
  }

  /* ---------- panel ---------- */
  function showEntry(en, item) {
    entries.forEach(function (x) { x.hidden = x !== en; });
    var h = en.querySelector('h3');
    if (h) panel.setAttribute('aria-labelledby', h.id);
    var src = item ? itemPhoto(item) : '';
    if (src) {
      if (photo.getAttribute('src') !== src) photo.src = src;
      photo.alt = h ? h.textContent : '';
      photo.hidden = false;
    } else {
      photo.hidden = true;
      photo.removeAttribute('src');
    }
    state.entry = en; state.item = item;
  }

  function place(anchor) {
    if (!anchor) return;
    var group = anchor.closest && (anchor.closest('.tpo_option-type-image-swatches-wrapper') || anchor.closest('.tpo_option-label'));
    var a = anchor.getBoundingClientRect(), g = group ? group.getBoundingClientRect() : a;
    var r = { left: g.left, right: g.right, top: a.top, bottom: a.bottom, width: g.width, height: a.height };
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var w = panel.offsetWidth, h = panel.offsetHeight;
    var left, top;
    if (r.left - w - 14 >= 12) {
      left = r.left - w - 14;
      top = Math.max(12, Math.min(r.top + r.height / 2 - h / 2, vh - h - 12));
    } else if (r.right + w + 14 <= vw - 12) {
      left = r.right + 14;
      top = Math.max(12, Math.min(r.top + r.height / 2 - h / 2, vh - h - 12));
    } else {
      left = Math.max(12, Math.min(r.left + r.width / 2 - w / 2, vw - w - 12));
      top = r.top - h - 10;
      if (top < 12) top = Math.max(12, Math.min(r.bottom + 10, vh - h - 12));
    }
    panel.style.left = Math.round(left + window.scrollX) + 'px';
    panel.style.top = Math.round(top + window.scrollY) + 'px';
  }

  function setExpanded(btn, on) { if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false'); }

  function openHover(en, item) {
    if (state.mode === 'full' || state.mode === 'sheet') return;
    clearTimeout(state.hideT);
    showEntry(en, item);
    panel.classList.add('is-hover');
    panel.classList.remove('is-sheet');
    panel.hidden = false;
    state.mode = 'hover';
    state.btn = item.querySelector('.gg-si-btn');
    place(item);
    if (!photo.hidden) photo.onload = function () { if (state.mode === 'hover' && state.item === item) place(item); };
  }

  function hideHoverSoon() {
    if (state.mode !== 'hover') return;
    clearTimeout(state.hideT);
    state.hideT = setTimeout(function () { if (state.mode === 'hover') close(false); }, 180);
  }

  function openFull(en, item, btn) {
    clearTimeout(state.hideT);
    if (state.btn && state.btn !== btn) setExpanded(state.btn, false);
    showEntry(en, item);
    panel.classList.remove('is-hover');
    panel.hidden = false;
    if (narrow()) {
      panel.classList.add('is-sheet');
      panel.style.left = ''; panel.style.top = '';
      if (backdrop) backdrop.hidden = false;
      state.mode = 'sheet';
    } else {
      panel.classList.remove('is-sheet');
      if (backdrop) backdrop.hidden = true;
      state.mode = 'full';
      place(item || btn);
      if (!photo.hidden) photo.onload = function () { if (state.mode === 'full' && state.item === item) place(item || btn); };
    }
    state.btn = btn;
    setExpanded(btn, true);
    closeBtn.focus({ preventScroll: true });
  }

  function close(returnFocus) {
    clearTimeout(state.hideT);
    var btn = state.btn, wasOpen = state.mode === 'full' || state.mode === 'sheet';
    panel.hidden = true;
    panel.classList.remove('is-hover', 'is-sheet');
    if (backdrop) backdrop.hidden = true;
    setExpanded(btn, false);
    state.mode = null; state.item = null;
    if (returnFocus && wasOpen && btn) btn.focus({ preventScroll: true });
  }

  closeBtn.addEventListener('click', function (e) { stop(e); close(true); });
  if (backdrop) backdrop.addEventListener('click', function () { close(true); });
  moreBtn.addEventListener('click', function (e) {
    stop(e);
    if (state.entry) openFull(state.entry, state.item, state.btn || (state.item && state.item.querySelector('.gg-si-btn')));
  });
  panel.addEventListener('mouseenter', function () { clearTimeout(state.hideT); });
  panel.addEventListener('mouseleave', hideHoverSoon);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.mode) close(true); });
  document.addEventListener('click', function (e) {
    if (state.mode !== 'full') return;
    if (panel.contains(e.target) || (e.target.closest && e.target.closest('.gg-si-btn'))) return;
    close(false);
  }, true);
  window.addEventListener('scroll', function () { if (state.mode === 'hover') close(false); }, { passive: true });
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return; /* phones fire resize when the browser bar shows or hides */
    lastW = window.innerWidth;
    if (state.mode) close(false);
  });

  /* ---------- buttons and hover on matched choices ---------- */
  function makeBtn(label, en, item) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gg-si-btn';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', 'gg-si-panel');
    b.setAttribute('aria-label', 'Details: ' + label);
    b.innerHTML = ICON + '<span>Details</span>';
    ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup'].forEach(function (t) {
      b.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: t === 'touchstart' });
    });
    b.addEventListener('click', function (e) {
      stop(e);
      if ((state.mode === 'full' || state.mode === 'sheet') && state.btn === b) { close(true); return; }
      openFull(en, item, b);
    });
    return b;
  }

  function enhance() {
    var containers = document.querySelectorAll('.tpo_option-container');
    Array.prototype.forEach.call(containers, function (c) {
      var title = norm(optionTitle(c));
      if (!title) return;
      var items = c.querySelectorAll('.tpo_swatches-label_position');
      Array.prototype.forEach.call(items, function (item) {
        if (item.getAttribute('data-gg-si')) return;
        var en = byKey[title + '||' + norm(itemLabel(item))];
        if (!en) return;
        item.setAttribute('data-gg-si', '1');
        var label = itemLabel(item).replace(/\s+/g, ' ').trim();
        var btn = makeBtn(label, en, item);
        var wrap = item.querySelector('.tpo_option_type_label_wrapper');
        if (wrap && wrap.parentNode === item) wrap.insertAdjacentElement('afterend', btn); else item.appendChild(btn);
        if (itemPhoto(item)) {
          var tile = item.querySelector('label');
          tile.addEventListener('mouseenter', function () { if (hoverable()) openHover(en, item); });
          tile.addEventListener('mouseleave', function () { if (hoverable()) hideHoverSoon(); });
          var inp = item.querySelector('input');
          if (inp) {
            inp.addEventListener('focus', function () {
              var fv = false; try { fv = inp.matches(':focus-visible'); } catch (x) {}
              if (fv && !narrow()) openHover(en, item);
            });
            inp.addEventListener('blur', hideHoverSoon);
          }
          var zoom = item.querySelector('.gg-zoom-btn');
          if (zoom) zoom.addEventListener('mouseenter', function () { if (state.mode === 'hover') close(false); });
        }
      });
      var sel = c.querySelector('select');
      if (sel && !c.querySelector('.gg-si-btnrow')) {
        var row = null;
        Array.prototype.forEach.call(sel.options, function (o) {
          var en = byKey[title + '||' + norm(o.textContent)];
          if (!en) return;
          if (!row) { row = document.createElement('div'); row.className = 'gg-si-btnrow'; }
          var label = clean(o.textContent);
          var b = makeBtn(label, en, null);
          b.querySelector('span').textContent = 'Details: ' + clean(o.textContent);
          row.appendChild(b);
        });
        if (row) sel.insertAdjacentElement('afterend', row);
      }
    });
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(enhance, 80); }
  later();
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(enhance, 3000);
})();
